import React, { createContext, useContext, useEffect, useState } from "react";
import { fetchPackagingTypes } from "services/packagingService";
import {
	fetchVehicleBrands,
	fetchVehicleModels,
	fetchVehicleTypes,
} from "services/vehicleSpecService";

interface GlobalDataContextProps {
	vehicleBrands: any[];
	vehicleTypes: any[];
	vehicleModels: any[];
	packagingTypes: any[];
	isFetched: boolean;
}

const GlobalDataContext = createContext<GlobalDataContextProps>({
	vehicleBrands: [],
	vehicleTypes: [],
	vehicleModels: [],
	packagingTypes: [],
	isFetched: false,
});

export const GlobalDataProvider: React.FC<{ children: React.ReactNode }> = ({
	children,
}) => {
	const [vehicleBrands, setVehicleBrands] = useState<any[]>([]);
	const [vehicleTypes, setVehicleTypes] = useState<any[]>([]);
	const [vehicleModels, setVehicleModels] = useState<any[]>([]);
	const [packagingTypes, setPackagingTypes] = useState<any[]>([]);
	const [isFetched, setIsFetched] = useState(false);

	useEffect(() => {
		if (!isFetched) {
			Promise.all([
				fetchVehicleBrands(),
				fetchVehicleTypes(),
				fetchVehicleModels(),
				fetchPackagingTypes(),
			])
				.then(([brandsRes, typesRes, modelsRes, packagingRes]) => {
					setVehicleBrands(brandsRes.data.data);
					setVehicleTypes(typesRes.data.data);
					setVehicleModels(modelsRes.data.data);
					setPackagingTypes(packagingRes);
					setIsFetched(true);
				})
				.catch((err) => console.error("Error fetching global data:", err));
		}
	}, [isFetched]);

	return (
		<GlobalDataContext.Provider
			value={{
				vehicleBrands,
				vehicleTypes,
				vehicleModels,
				packagingTypes,
				isFetched,
			}}
		>
			{children}
		</GlobalDataContext.Provider>
	);
};

export const useGlobalData = () => useContext(GlobalDataContext);
